import PeopleContainer from './PeopleContainer';

export default PeopleContainer;
